export default __webpack_public_path__ + "static/Graph1-04a08e6023ec07217fd7b6f36fededb9.webp";